import { graphql } from '../../graphql';
import execute from '../../helpers/functions/api';

export const getStripePriceOpenDataConfig = () => {
  const query = graphql(`
    query getStripePriceOpenDataConfig {
      getStripePriceOpenDataConfig {
        prices {
          priceId
          amount
          areaUnit
          currency
          interval
          intervalCount
          plan
          price
          triggerSource
          volumePricing {
            max
            min
            price
          }
        }
        productKey
        productName
        productId
      }
    }
  `);

  return execute({
    query,
    withApiKey: true,
  });
};
